import * as React from 'react';
import Switch from 'react-switch';
import { useTheme } from '@emotion/react';
import { Theme } from '../../theme';

export interface SwitchWidgetProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const SwitchWidget: React.FC<SwitchWidgetProps> = (props) => {
  const theme = useTheme() as Theme;

  return (
    <Switch
      checked={props.checked}
      disabled={props.disabled}
      onChange={props.onChange}
      onHandleColor={theme.forms.toggle.handleColor}
      offHandleColor={theme.forms.toggle.handleColor}
      onColor={theme.forms.toggle.onColor}
      offColor={theme.forms.toggle.offColor}
      borderRadius={3}
      height={18}
      width={50}
    />
  );
};
